<template>
    <div class="login">

        <div class="main flex">
            <div class="login-box">
                <div class="title">忘记密码</div>
                <el-form ref="form" :model="form" :rules="rules">
                    
                    <el-form-item prop="password">
                        <el-input
                            :show-password="true"
                            type="password"
                            placeholder="请输入新密码"
                            prefix-icon="el-icon-lock"
                            v-model="form.password" />
                    </el-form-item>
                    <el-form-item prop="mobile">
                        <el-input
                            placeholder="请输入用户名/手机号"
                            onkeyup="this.value=this.value.replace(/[^\0-9]/g, '')"
                            prefix-icon="el-icon-user"
                            v-model="form.mobile" />
                    </el-form-item>
                    <el-form-item prop="code">
                        <div class="flex">
                            <el-input placeholder="请输入验证码" v-model="form.code"></el-input>
                            <el-button @click="getCode" :disabled="isCodeSend">
                                {{codeContent}}
                            </el-button>
                        </div>
                    </el-form-item>
                </el-form>
                <el-button type="primary" class="loginBtn" @click="login">登录</el-button>
                <div class="back" @click="goBack">返回登录页</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: {
                mobile: '',
                password: '',
                code: '',
            },
            rules: {
                mobile: [{
                    required: true, message: '请输入登录账户', trigger: 'blur'
                }],
                password: [{
                    required: true, message: '请输入密码', trigger: 'blur'
                }],
                code: [{
                    required: true, message: '请填写验证码', trigger: 'blur'
                }]
            },
            codeContent: '获取验证码',
            isCodeSend: false,
            ddl: 60
        }
    },
    methods: {
        getCode(){
            if(this.form.mobile === ''){
                return this.$message.error('请输入手机号码');
            }
            if(this.isCodeSend === true){
                return;
            }else{
                this.$http.post(this.common.company + '/api/sendMobileCode', {
                    mobile: this.form.mobile
                }).then(res => {
                    if(res.code === 200){
                        this.$message.success('验证码已发送');
                        this.isCodeSend = true;
                        this.codeContent = `${this.ddl}秒后重新发送`;
                        let timer = setInterval(() => {
                            this.ddl--;
                            this.codeContent = `${this.ddl}秒后重新发送`;
                            if(this.ddl <= 0){
                                clearInterval(timer);
                                this.codeContent = '获取验证码';
                                this.ddl = 60;
                                this.isCodeSend = false;
                            }
                        }, 1000);
                    }else{
                        return this.$message.error(res.msg);
                    }
                });
                
            }
        },
        login(){
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$http.post(this.common.company + '/company/forgotPassword', this.form).then(res => {
                        if(res.code === 200){
                            this.$store.commit('setToken', res.data.api_token);
                            // localStorage.setItem('token', res.data.api_token);
                            localStorage.removeItem('userType');
                            localStorage.setItem('userType', 'company');
                            let info = JSON.stringify(res.data);
                            localStorage.setItem('userInfo', info);
                            this.$store.commit('setTag', {
                                name: '首页',
                                path: {path: '/main/home'},
                            });
                            this.$message.success('登录成功');
                            this.$router.push({
                                path: '/main/home'
                            })
                        }else{
                            this.$message.error(res.msg);
                        }
                    });
                } else {
                    return this.$message.error('请检查输入信息是否输入完整');
                }
            });
        },
        goBack(){
            this.$router.back();
        }
    },
}
</script>
<style lang="less" scoped>
    .login{
        height: 100%;
        background-image: url('./../assets/img/login_bg.png');
        background-size: 100% 100%;
        .header{
            padding-left: 400px;
            height: 80px;
            font-size: 30px;
            color: #161616;
            background-color: #fff;

            align-items: center;
        }

        .main{
            height: calc(100% - 80px);
            align-items: center;
            justify-content: center;
            .login-box{
                padding: 50px 30px;
                width: 20%;
                min-width: 400px;
                background-color: #fff;
                border-radius: 18px;

                .title{
                    margin-bottom: 40px;
                    font-size: 24px;
                    color: #333;
                    text-align: center;
                }

                /deep/.el-input__inner{
                    height: 50px;
                    font-size: 16px;
                }
                
                .other{
                    margin: 20px 0;
                    justify-content: flex-end;
                    .forgot{
                        font-size: 16px;
                        color: #989898;
                        cursor: pointer;

                        &:hover{
                            color: #7c7c7c;
                        }
                    }
                }
                .loginBtn{
                    width: 100%;
                    height: 50px;
                    font-size: 18px;
                    color: #fff;
                    border-radius: 6px;
                    cursor: pointer;
                }
                .back{
                    margin-top: 10px;
                    text-align: right;
                    font-size: 16px;
                    color: #989898;
                    cursor: pointer;

                    &:hover{
                        color: #4f4e4e;
                        font-weight: 500;
                    }
                }
            }
        }
    }
</style>